import * as React from "react";
const SvgProductboard = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "#FF2638", d: "m8 12 8 8H0z" }),
    React.createElement("path", { fill: "#FFC600", d: "m0 4 8 8 8-8z" }),
    React.createElement("path", { fill: "#0079F2", d: "m8 12 8 8 8-8-8-8z" })));
export default SvgProductboard;
//# sourceMappingURL=Productboard.js.map